import * as React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useHistory } from 'react-router';
import { SessionContext } from '../../context/Session';
import PageHeader from '../../components/PageHeader';

export default function CustomOrderStatus() {
  const history = useHistory();
  const { purchaseItem, setPurchaseItem } = React.useContext(SessionContext);
  const [customOrderId, setCustomOrderId] = React.useState();

  React.useEffect(() => {
    getCustomOrder();
  }, []);

  const pageHeader = {
    title: `Custom Orders`,
    description:
      "Multiple lines of text that form the lede, informing new readers quickly and efficiently about what's most interesting in this post's contents.",
    image: 'https://source.unsplash.com/random',
    imageText: 'main image description',
  };

  const getCustomOrder = () => {
    setCustomOrderId(
      history.location.pathname.split('custom-order/status/')[1]
    );
    fetch(
      `https://sheline-art-website-api.herokuapp.com/custom-orders/item/${
        history.location.pathname.split('custom-order/status/')[1]
      }`
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setPurchaseItem(result);
          console.log(result);
        },
        (error) => {
          console.log(error);
        }
      );
  };
  if (purchaseItem) {
    return (
      <React.Fragment>
        <Container
          disableGutters
          maxWidth='2xl'
          component='main'
          sx={{ pt: 8, pb: 6 }}
        >
          <PageHeader post={pageHeader} />
          <Typography
            sx={{ my: 1, fontSize: 50, mt: { xs: 5, md: 0 } }}
            variant='primary'
            component='div'
            align='center'
          >
            Custom Order for
          </Typography>
          <Typography
            sx={{ my: 1, fontSize: 40, mt: { xs: 5, md: 0 } }}
            variant='primary'
            component='div'
            align='center'
          >
            {purchaseItem.name}
          </Typography>
          <Typography
            sx={{ my: 1, mx: 20, fontSize: 40, mt: { xs: 5, md: 10 } }}
            variant='primary'
            component='div'
            align='center'
          >
            Status: {purchaseItem.status}
          </Typography>
          <Typography
            sx={{ my: 1, fontSize: 50, mt: { xs: 5, md: 5 } }}
            variant='primary'
            component='div'
            align='center'
          >
            From Shey:
          </Typography>
          <Typography
            sx={{ my: 1, mx: 20, fontSize: 30, mt: { xs: 5, md: 0 } }}
            variant='primary'
            component='div'
            align='center'
          >
            {purchaseItem.shey_description}
          </Typography>
          <Typography
            sx={{ my: 1, mx: 20, fontSize: 50, mt: { xs: 5, md: 5 } }}
            variant='primary'
            component='div'
            align='center'
          >
            My Description
          </Typography>
          <Typography
            sx={{ my: 1, mx: 20, fontSize: 30, mt: { xs: 5, md: 0 } }}
            variant='primary'
            component='div'
            align='center'
          >
            {purchaseItem.description}
          </Typography>
          <Typography
            sx={{ my: 1, mx: 20, fontSize: 50, mt: { xs: 5, md: 10 } }}
            variant='primary'
            component='div'
            align='center'
          >
            TOTAL: {purchaseItem.total}
          </Typography>
        </Container>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Container
          disableGutters
          maxWidth='2xl'
          component='main'
          sx={{ pt: 8, pb: 6 }}
        >
          <PageHeader post={pageHeader} />
        </Container>
      </React.Fragment>
    );
  }
}
